function resolvUrlBrand(urlHost, config){ 
  const brandsDass = Object.freeze({   
    umbro : 'umbro.com.br',
    fila : 'fila.com.br',
    newbalance: 'newbalance.com.br'
  }) 
  let urlDomain = ''
  if(urlHost.includes(brandsDass.fila))
    urlDomain = config.VUE_APP_URL_API_FILA
  else if (urlHost.includes(brandsDass.umbro))
    urlDomain = config.VUE_APP_URL_API_UMBRO
  else if (urlHost.includes(brandsDass.newbalance))
    urlDomain = config.VUE_APP_URL_API_NEW_BALANCE
  else
    urlDomain = config?.VUE_APP_FULL_URL_API || process.env.VUE_APP_FULL_URL_API

  return urlDomain
}
import axios from 'axios'
import login from '@/services/login'
import router from '../routers'
import { getConfig } from './service'
import {
  showError,
  beginLoading,
  endLoading,
} from '../store/modules/toasts/actions'
let activeRequests = 0;
axios.defaults.withCredentials = true
async function createAPI() {
  const config = await getConfig()  
  const baseURL = resolvUrlBrand(window.location.host, config) 
  const api = axios.create({
    baseURL,
    headers: {},
  })
  api.withCredentials = true

  function addHeaders(config) {
    config.headers.HTTP_CONTENT_LANGUAGE =
      store.getters['translation/selectedLanguage']
    return config
  }

  function handleRequestSuccess(req) {  
    if (req.url && urlHasLoadingEffect(req.url)) {      
      if (activeRequests === 0) {
        beginLoading();
      }
      activeRequests++;
    }
    // TODO
    return req
  }
  async function handleRequestError(err) {    
    if (err.response && err.response.status === 401) {
      await login.doLogout()
      window.reload()
    }

    return err
  }
  function handleResponseSuccess(res) {
     const url = res.request.responseURL || ''
    if (url && urlHasLoadingEffect(url)) {
      activeRequests--;      
      if (activeRequests <= 0) {
        activeRequests = 0; // Garantia de segurança
        endLoading();
      }
    }

    // TODO
    return res
  }
  async function handleResponseError(err) {
    const url = err.request?.responseURL || ''
    if (url && urlHasLoadingEffect(url)) {      
      activeRequests--;      
      if (activeRequests <= 0) {
        activeRequests = 0; 
        endLoading();
      }
      
    }

    let treated_error = {
      status: '',
      message: 'Sem conexão com o servidor',
    }
    let error_level = {
      name: 'Erro',
      level: 'error',
    }  
    if (err.hasOwnProperty('response') && err.response) {
      let response = err.response
      if (response.hasOwnProperty('data') && response.data) {
        let response_data = response.data
        treated_error.message = response_data.message
        treated_error.status = response.status
        treated_error.detail = response_data.detail || response_data.details
        error_level = switchAPIErrorType(response_data.type || '')
      }
    }
    if (
      treated_error &&
      treated_error.hasOwnProperty('status') &&
      treated_error.status == 401 &&
      router.currentRoute?.value?.path !== '/login'
    ) {
      showError(
        treated_error.message || 'Houve um erro ao carregar sua sessão faça login novamente.',
        'warning'
      )
      setTimeout(async () => {
        await login.doLogout() 
        router.push('/login')
      }, 2000)
      return Promise.reject(treated_error)
    }

    let cod_message =
      treated_error.status != ''
        ? `Código: ${treated_error.status}`
        : '                      '

    let message = `${error_level.name}! ${cod_message}                              ${treated_error.message}`

    if (
      err.hasOwnProperty('response') &&
      err.response.hasOwnProperty('request')
    ) {
      let request = err.response.request
      if (request.responseURL != undefined && request.responseURL) {
        let url = request.responseURL
        if (urlHasErrorEffect(url)) {
          showError(message, error_level.level)
        }
      }
    }
    return Promise.reject(treated_error)
  }

  // Add a request interceptor
  api.interceptors.request.use(
    handleRequestSuccess,
    handleRequestError,
    addHeaders
  )
  // Add a response interceptor
  api.interceptors.response.use(handleResponseSuccess, handleResponseError)


  function switchAPIErrorType(type) {
    let error_level = { type: 'error', name: 'Erro' }
    switch (type) {
    case 'WARN':
      error_level.name = 'Aviso'
      error_level.level = 'warning'
      break
    }
    return error_level
  }

  /** remove de algumas rotas o efeito de loading */
  function urlHasLoadingEffect(url) {    
    if (
      url.includes('authentication/valid') ||
      url.includes('authentication/profile') || 
      url.includes('protocols/reasons/b2c') ||
      url.includes('protocols/subjects/b2c') ||      
      url.includes('/bank') ||
      url.includes('/settings') || 
      url.includes('wallet/b2c/total')            
    ) {
      return false
    }
    return true
  }

  /** remove de algumas rotas o efeito de erro */
  function urlHasErrorEffect(url) {
    if (
      url.includes('authentication/valid') ||
      url.includes('authentication/profile')
    ) {
      return false
    }
    return true
  }

  return api
}
let clientAPI = null
export const getClientAPI = async () => {
  if (!clientAPI) {
    clientAPI = await createAPI()
  }
  return clientAPI
}
getClientAPI()

export { clientAPI }